import React, { useEffect, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontSize } from "../../component/theme/fontSize";
import { fontWeight } from "../../component/theme/fontWeight";
import { ThemeColor } from "../../component/theme/color";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import UniversityOverviewSection from "./UniversityOverviewSection.page";
import UniversityProccessListSection from "./UniversityProccessListSection.page";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UniversityDetailsService } from "../../Redux/service/SettingService";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function UniversityOverviewPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [value, setValue] = React.useState(0);
  const { id } = useParams();

  const [Edit, setEdit] = useState(id ? true : false);
  const [prefieldData, setPrefieldData] = useState();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    GetUniversityDetails();
  }, [Edit, id]);

  const GetUniversityDetails = async () => {
    await UniversityDetailsService(id).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        setPrefieldData(res.data.data);
      }
    });
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  return (
    <>
      <Box sx={{ background: "white", p: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton>
            <Typography
              fontFamily={FontFamily.Lato}
              fontSize={fontSize.h2.medium}
              fontWeight={fontWeight.W600}
            >
              {prefieldData?.university?.name}
            </Typography>
            <Typography
              className="mt-2"
              fontFamily={FontFamily.Lato}
              fontSize={fontSize.h3.medium}
              fontWeight={fontWeight.W400}
            >
              {prefieldData?.university?.country}{" "}
              {prefieldData?.university?.state},{prefieldData?.university?.city}
            </Typography>
          </div>
          <div style={{ width: 120, height: 120 }}>
            <img
              className="w-100 h-100"
              src={prefieldData?.university?.logo}
            ></img>
          </div>
        </Box>
        <Divider sx={{ borderColor: ThemeColor.GREY, mt: 2 }} />
        <Grid container spacing={2} mt={2}>
          {/* {prefieldData?.university?.images &&
          prefieldData?.university?.images.map((img) => (
            <Grid item lg={8} sm={12} sx={{ height: 440 }}>
              <img
                style={{ borderRadius: 10 }}
                src={img.url}
                className="w-100 h-100"
              ></img>
            </Grid>
          ))} */}
          <Grid item lg={8} sm={12} sx={{ height: 440 }}>
            <img
              style={{ borderRadius: 10 }}
              src={prefieldData?.university?.images?.[0]?.url}
              className="w-100 h-100"
            ></img>
          </Grid>

          <Grid item lg={4}>
            <Grid container spacing={2}>
              <Grid item lg={12} sm={12} sx={{ height: 220 }}>
                <img
                  style={{ borderRadius: 10 }}
                  src={prefieldData?.university?.images?.[1]?.url}
                  className="w-100 h-100"
                ></img>
              </Grid>
              <Grid item lg={12} sm={12} sx={{ height: 220 }}>
                <img
                  style={{ borderRadius: 10 }}
                  src={prefieldData?.university?.images?.[2]?.url}
                  className="w-100 h-100"
                ></img>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box sx={{ width: "100%" }} mt={2}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab label="Overview" {...a11yProps(0)} />
              <Tab label="Process List" {...a11yProps(1)} />
              <Tab label="Catalogue Brochure" {...a11yProps(2)} />
              <Tab label="Courses" {...a11yProps(3)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <UniversityOverviewSection
              data={prefieldData?.university?.description}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <UniversityProccessListSection
              columns={[
                // {
                //   field: "id",
                //   headerName: "ID",
                //   width: 350,
                // },
                {
                  field: "name",
                  headerName: "Document Name",
                  width: 650,
                },
                // {
                //   field: "program",
                //   headerName: "Program Name",
                //   width: 350,
                // },
                // {
                //   field: "documentUrl",
                //   headerName: "Document URL",
                //   width: 150,
                //   renderCell: (params) => (
                //     <a
                //       href={params.value}
                //       target="_blank"
                //       rel="noopener noreferrer"
                //     >
                //       Open Document
                //     </a>
                //   ),
                // },
              ]}
              row={prefieldData?.processSheets?.files?.map(
                ({ _id, ...rest }) => ({
                  id: _id,
                  ...rest,
                })
              )}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <UniversityProccessListSection
              columns={[
                // {
                //   field: "id",
                //   headerName: "ID",
                //   width: 390,
                // },
                // {
                //   field: "name",
                //   headerName: "Document Name",
                //   width: 350,
                // },
                {
                  field: "name",
                  headerName: "Catalogue Name",
                  width: 650,
                },
                // {
                //   field: "documentUrl",
                //   headerName: "Document URL",
                //   width: 150,
                //   renderCell: (params) => (
                //     <a
                //       href={params.value}
                //       target="_blank"
                //       rel="noopener noreferrer"
                //     >
                //       Open Document
                //     </a>
                //   ),
                // },
              ]}
              row={prefieldData?.catalog?.files?.map(({ _id, ...rest }) => ({
                id: _id,
                ...rest,
              }))}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <UniversityProccessListSection
              type="program"
              columns={[
                // {
                //   field: 'id',
                //   headerName: 'ID',
                //   width: 90,
                // },
                {
                  field: "name",
                  headerName: "Program Name",
                  width: 650,
                },
                {
                  field: "degree",
                  headerName: "Degree",
                  width: 650,
                },
                // {
                //   field: "documentUrl",
                //   headerName: "Document URL",
                //   width: 150,
                //   renderCell: (params) => (
                //     <a
                //       href={params.value}
                //       target="_blank"
                //       rel="noopener noreferrer"
                //     >
                //       Open Document
                //     </a>
                //   ),
                // },
              ]}
              row={prefieldData?.programs
                ?.map(({ _id, ...rest }) => ({
                  id: _id,
                  ...rest,
                }))
                // .sort((a, b) => a.name.localeCompare(b.name))
              }
            />
          </CustomTabPanel>
        </Box>
      </Box>
    </>
  );
}
function UniversityOverview() {
  return <ResponsiveDrawer maincontent={<UniversityOverviewPage />} />;
}

export default UniversityOverview;
